<template>
  <div>
    
     <v-row v-for="(question, index) in values.questions" :key="index">
        <v-col class="py-2">
            <!-- OPEN TYPE -->
            <div v-if="question.type == 'open'">
                <textAreaForm
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    @valueChange="(v) => {question.response = v.trim(); delete serverErrors[`q_${index}`]}" 
                    :valueInput="question.response" 
                    :rule="question.required && !previewMode ? rules.required : []" 
                    :label="question.question"
                    :errorMessages="serverErrors[`q_${index}`]"
                    class="questionnarie-form-input"
                    :rows="1"
                    :readonly="previewMode"
                ></textAreaForm>
            </div>


            <!-- BINARY TYPE -->
            <div v-if="question.type == 'binary'">
                <ToggleOptionSurveyVue
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    :asterisk="question.required ? true : false"
                    :valueInput="question.response"
                    @valueChange="(v) => {question.response = v; delete serverErrors[`q_${index}`]}" 
                    :label="question.question"
                    :items="question.add_not_apply ? toggleItemsYesNoNotAply : toggleItemsYesNo"
                    :errorMessage="serverErrors[`q_${index}`]"
                    :rule="question.required && !previewMode ? rules.required : []"
                    :readonly="previewMode"
                />
            </div>

            <!-- UPLOAD IMAGE TYPE -->
            <div v-if="question.type == 'upload_image'">
                <fileInputForm
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    class="questionnarie-form-input"
                    :label="question.question"
                    :multiple="true"
                    :valueInput="question.response"
                    :url="''"
                    :rule="question.required && !previewMode ? rules.fileRequired : []"
                    @valueChange="(v) => {question.response = v; delete serverErrors[`q_${index}`]}"
                    :errorMessages="serverErrors[`q_${index}`]"
                    v-on:update:url="question.poster_url = $event"
                    :disabled="previewMode"
                ></fileInputForm>
            </div>

            <!-- TIME TYPE -->
            <div v-if="question.type == 'time'">
                <timePickerForm
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    :label="question.question"
                    :valueInput="question.response"
                    :rule="question.required && !previewMode ? rules.required : []"
                    @valueChange="
                        (v) => {
                            question.response = v;
                            delete serverErrors[`q_${index}`];
                        }
                    "
                    :errorMessages="serverErrors[`q_${index}`]"
                   class="questionnarie-form-input"
                   :readonly="previewMode"
                ></timePickerForm>
            </div>

            <!-- DATE TYPE -->
            <div v-if="question.type == 'date'">
                <datePickerForm
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    class="questionnarie-form-input"
                    :label="question.question"
                    :valueInput="question.response"
                    :rule="question.required && !previewMode ? rules.required : []"
                    :hideIcon="false"
                    
                    @valueChange="(v) => {question.response = v; delete serverErrors[`q_${index}`]}"
                    :errorMessages="serverErrors[`q_${index}`]"
                    :readonly="previewMode"
                ></datePickerForm>
            </div>

            <!-- MULTI TYPE -->
            <div v-if="question.type == 'multi'">
                <ToggleOptionSurveyVue
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    :asterisk="question.required ? true : false"
                    :valueInput="question.response"
                    @valueChange="(v) => {question.response = v; delete serverErrors[`q_${index}`]}" 
                    :label="question.question"
                    :items="loadMultiOptionsItems(question.option_list)"
                    :errorMessage="serverErrors[`q_${index}`]"
                    :readonly="previewMode"
                />
            </div>

            <!-- NUMERIC TYPE -->
            <div v-if="question.type == 'number'">
                <textAreaForm 
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    @valueChange="(v) => {question.response = v.trim(); delete serverErrors[`q_${index}`]}" 
                    :valueInput="question.response" 
                    :rule="question.required && !previewMode ? [...rules.required, ...rules.isNumber] : [...rules.isNumber]" 
                    :label="`${question.question} (${question.unit})`"
                    :errorMessages="serverErrors[`q_${index}`]"
                    class="questionnarie-form-input"
                    :rows="1"
                    :readonly="previewMode"
                ></textAreaForm>
            </div>

            <div v-if="question.type == 'scale'">
                <SliderInputForm
                    :surveyMode="true"
                    :sublabel="question.instructions"
                    :asterisk="question.required ? true : false"
                    class="questionnarie-form-input"
                    :label="question.question"
                    :ticksLabers="[question.start_tag, '', '', '', question.end_tag]"
                    :valueInput="question.response"
                    @valueChange="(v) => {question.response = v; delete serverErrors[`q_${index}`]}"
                    min="0"
                    max="4"
                    :errorMessage="serverErrors[`q_${index}`]"
                    :readonly="previewMode"
                />
                       
            </div>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import ToggleOptionSurveyVue from '../../../../components/ToggleOptionSurvey.vue';
/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'previewMode'],
    components: {
        ToggleOptionSurveyVue,
    },
    computed: {
        
    },
    watch: {
        'serverErrors': function(v){
            console.log(v, "watch desde form")
        }
    },
    data(){
        return {
         

          questionsIndex:[],

            toggleItemsYesNo:[
                {text: "Si", value: "Si"},
                {text: "No", value: "No"},
            ],
            toggleItemsYesNoNotAply:[
                {text: "Si", value: "Si"},
                {text: "No", value: "No"},
                {text: "No aplica", value: "NA"},
            ],
          
          rules: {
            required: [
                v => !!v || 'El campo es requerido'
            ],
            fileRequired: [
                v => {
                    console.log(v, "vvv")
                    if(v == null || v.length == 0)
                        return "El campo es requerido"
                    return true
                }
            ],

            isNumber: [
                (v) => {
                    // if (!v) return "El campo es requerido";
                    if(v != null && v != ""){
                        if (v != null && !v.match("^[0-9]+(.[0-9]{1,9})?$"))
                            return "Solo números";
                    }
                   
                   
                   
                    return true;
                },
            ],


            name: [
                v => {
                    if(v == null || v == undefined)
                        return "Campo requerido";
                    try {
                        if(v.trim() == "")
                            return "Campo requerido";
                    } catch (error) {
                        console.log(error);
                    }
                    return true;
                }
            ],
            type: [
                v => !!v || 'El campo es requerido'
            ],
            apply_for:[
                v => {
                    if(v.length == 0)
                    return 'Al menos uno';
                    return true;
                }
            ],
           


            action_response: [
                v => !!v || 'El campo es requerido'
            ],

            to: [
                v => !!v || 'El campo es requerido b'
            ],
          

          },


          serverItems: {
            
          },


         

          
        }
    },
    mounted(){
      this.generateQuestionsIndexList();
    },
    methods: {


      /**
       * Create a list of questions
       * use with "salto de pregunta"
       */
      generateQuestionsIndexList()
      {
        this.questionsIndex = [];
        for (let i = 0; i < this.values.questions.length; i++) {
          this.questionsIndex.push({text:`Pregunta ${i+1}`, value:i});
        }
      },

        loadMultiOptionsItems(list = [])
        {
            let data = [];
            list.forEach(item => {
                data.push({text: item.option, value: item.option},)
            });

            return data;
        }


      
    }
}
</script>

<style lang="scss">
    .questionnarie{
        &-form-input {
            label {
                font-size: .8rem !important;
            }

            
        }
        
    }
    
</style>